export default {"src":"/_next/static/media/image.6cd14e4c.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};